export function useDownloadPDF() {
    const downloadPDF = (pdfBlob, filename) => {
        if (!pdfBlob) {
            return false;
        }
        try {
            const url = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${filename}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            return true;
        }
        catch (error) {
            return false;
        }
    };
    const createPDFBlob = (bufferData) => {
        if (!bufferData) {
            return null;
        }
        try {
            const uint8Array = new Uint8Array(bufferData);
            return new Blob([uint8Array], { type: 'application/pdf' });
        }
        catch (error) {
            return null;
        }
    };
    return { downloadPDF, createPDFBlob };
}
